<template>
  <div>
    <b-form @submit.prevent="save" v-if="!isLoading">
      <b-row>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.user"
            label-for="userSelected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.user"
              :rules="$v.userSelected.$params"
            />
            <selectAsync
              :options="user_options"
              v-model="$v.userSelected.$model"
              :overrideLabel="false"
              :asyncFind="getUser"
              :isValid="$v.userSelected.$dirty ? !$v.userSelected.$error : null"
              label="name"
              id="code"
              :disabled="mode === 'EDIT'"
            >
            </selectAsync>
            <b-form-invalid-feedback id="person_id-feedback"
              >{{ $lang.error_required | replace($lang.person) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.caption"
            label-for="name"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.caption"
              :rules="$v.name.$params"
            />
            <b-form-input
              id="name"
              type="text"
              v-model="$v.name.$model"
              :state="$v.name.$dirty ? !$v.name.$error : null"
              :autocomplete="$lang.caption"
            ></b-form-input>
            <b-form-invalid-feedback id="name-feedback"
              >نام ضروری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.explanation"
            label-for="address"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.explanation"
              :rules="$v.description.$params"
            />
            <editor dir="rtl" v-model="$v.description.$model">
              <br />
            </editor>
            <b-form-invalid-feedback id="person_id-feedback"
              >{{ $lang.error_required | replace($lang.explanation) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.show_at"
            label-for="show_at"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.show_at"
              :rules="$v.show_at.$params"
            />
            <date-picker
              v-model="$v.show_at.$model"
              :state="$v.show_at.$dirty ? !$v.show_at.$error : null"
              type="datetime"
              inputReq="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="dddd jDD jMMMM jYYYY HH:mm"
              min="1900/01/02"
              :roundMinute="true"
              :clearable="true"
              :class="
                $v.show_at.$dirty
                  ? $v.show_at.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback id="show_at-feedback"
              >زمان شروع ضروری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col xs="12" md="12">
          <b-form-group
            :label="$lang.end_at"
            label-for="end_at"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.end_at"
              :rules="$v.end_at.$params"
            />
            <date-picker
              v-model="$v.end_at.$model"
              :state="$v.end_at.$dirty ? !$v.end_at.$error : null"
              type="datetime"
              inputReq="true"
              :clearable="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="dddd jDD jMMMM jYYYY HH:mm"
              min="1900/01/02"
              :roundMinute="true"
              :class="
                $v.end_at.$dirty
                  ? $v.end_at.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback id="end_at-feedback"
              >زمان شروع ضروری است</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.status"
            label-for="status_selected"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.status"
              :rules="$v.status_selected.$params"
            />
            <selectFind
              :options="status_options"
              v-model="$v.status_selected.$model"
              label="text"
              :isValid="
                $v.status_selected.$dirty ? !$v.status_selected.$error : null
              "
              :loading="statusLoading"
            />

            <b-form-invalid-feedback
              id="status_selected-feedback"
              :style="{ display: $v.status_selected.$error ? 'block' : 'none' }"
            >
              {{
                $lang.error_required | replace($lang.status)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="start_at_time"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.start_at_time }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.start_at_time_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12" class="white-space mt-2">
          <b-form-checkbox
            id="checkbox-2"
            v-model="start_at_period"
            name="checkbox-2"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.start_at_period }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.start_at_period_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>

        <b-col xs="12" md="12" v-if="showUpload" class="mt-2">
          <uploadFile
            v-if="taskId"
            :keyServies="`task`"
            :keyValue="taskId"
            :file_types="file_types"
          />
        </b-col>
        <b-col v-if="!showUpload" cols="12" md="12" class="mt-2">
          <label for="">{{ $lang.send_file }}</label>
          <fileDrag
            ref="fileDrag"
            @uploadFile="attachmentTemp"
            :acceptFormats="acceptFormats"
            :acceptFormatsInput="acceptFormatsInput"
            :multiple="true"
            :crop="false"
          />
          <filelistPorgress
            :fileUpload="fileUpload"
            @removeFile="removeFileProgress"
            @removeFiles="removeFiles"
            @getResponseCode="filesCode"
            :showButton="false"
          />
        </b-col>
        <b-col xs="12" md="12">
          <div slot="footer" class="form-group form-btn">
            <b-button type="submit" size="md" variant="success">
              {{ $lang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cancel"
            >
              {{ $lang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import { renderEumOptions, renderEumOptionsSelected } from "@/shared/utils";
import { pathOr } from "ramda";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import uploadFile from "@/components/base/uploadFile";
import filelistPorgress from "@/components/fileManager/filelistPorgress";
import fileDrag from "@/components/fileManager/fileDrag";
import editor from "@/components/ckeditor/editor";
import { createPureDom } from "@/shared/utils";
export default {
  validations: {
    userSelected: {
      required,
    },
    show_at: {
      required,
    },
    end_at: {},
    name: {
      required,
    },
    description: { required },
    status_selected: {
      required,
    },
  },
  name: "task-from",
  components: {
    datePicker: VuePersianDatetimePicker,
    uploadFile,
    filelistPorgress,
    fileDrag,
    editor,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "ADD",
    },
  },
  data() {
    return {
      acceptFormatsInput:
        "image/jpeg,image/jpg,image/png,image/bmp,application/msword",
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      file_types: ["image", "office", "media", "other"],
      fileManagerModal: false,
      user_options: [],
      userSelected: null,
      show_at: null,
      end_at: null,
      name: null,
      description: null,
      taskId: null,
      start_at_time: 0,
      start_at_period: 0,

      fileUpload: [],
      responseCode: [],
      btnHidden: false,
      attachmentId: null,

      status_selected: null,
      statusLoading: false,
    };
  },
  computed: {
    status_options() {
      return renderEumOptions("task_status");
    },
  },
  methods: {
    createPureDom,
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
    },
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    filesCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    async removeFiles(item) {
      this.$emit("closeModal");
    },
    /**
     * @vuese
     * لغو کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    cancel() {
      this.$emit("modal-end-up", false);
    },
    getUser(query) {
      if (!query || query.length < 3) {
        this.user_options = [];
        return;
      }
      this.$httpService
        .get(
          this.$config.api_url +
            this.$config.resources.user +
            "?search_txt=" +
            query
        )
        .then((response) => {
          let user = response.data.data.result.map((x) => {
            x.name = x.person.name;
            return x;
          });
          this.user_options = user;
        })
        .catch((err) => {
          this.user_options = [];
        });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        user_code: this.userSelected && this.userSelected.code,
        name: this.name,
        description: this.description,
        show_at: this.show_at,
        end_at: this.end_at,
        status: this.status_selected && this.status_selected.value,
        start_at_time: parseInt(this.start_at_time),
        start_at_period: parseInt(this.start_at_period),
        action: null,
      };
      this.$emit("submit", payload);
    },
    fileManager() {
      this.fileManagerModal = true;
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        if (this.item.user) {
          let user = {
            name: this.item.user.name,
            code: this.item.user.code,
          };
          this.userSelected = user;
        }
        (this.show_at = this.item.show_at && this.item.show_at.gregorian),
          (this.end_at = this.item.end_at && this.item.end_at.gregorian),
          (this.name = this.item.name),
          (this.description = createPureDom(this.item.description));
        this.taskId = this.item.code;
        (this.start_at_time = this.item.start_at_time),
          (this.start_at_period = this.item.start_at_period);

        this.status_selected = renderEumOptionsSelected(
          "task_status",
          pathOr(null, ["status", "id"], this.item)
        );
      }
    },
  },
  watch: {
    userSelected() {},
  },
  created() {
    this.fetchData();
  },
};
</script>
